import {RouteObject} from 'react-router-dom';
import {authGuard} from '@common/auth/guards/auth-route';

export const appAdminRoutes: RouteObject[] = [
  {
    path: 'cost-control',
    loader: () => authGuard({permission: 'admin.access'}),
    lazy: () => import('@app/admin/cost-control/cost-control-page'),
  },
];
